module.exports = __webpack_public_path__ + "img/woman-illustration.12c2eabd.svg";